import { Component } from "@angular/core";

@Component({
  selector: "app-survey",
  standalone: false,
  templateUrl: "./survey.component.html",
  styleUrl: "./survey.component.scss",
})
export class SurveyComponent {}
